import * as Yup from "yup";

const ForgetPasswordSchema = Yup.object().shape({
  userName: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter valid email Id")
    .required("Please enter email Id"),
});

export default ForgetPasswordSchema;
